module.exports = __webpack_public_path__ + "static/media/Silestone-Flash Promo-Digital-Flyer-CANADA.5f64a6b5.pdf";